(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-parts-guide]').forEach(root => {
      const picker = root.querySelector('[data-parts-picker]');
      if (!picker || picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const groups = [...root.querySelectorAll('[data-part-category]')];
      const picks = [...picker.querySelectorAll('[data-pick]')];
      const choice = picker.querySelector('[data-pick-choice]');
      const feet = picker.querySelector('[data-pick-feet]');
      const results = picker.querySelector('[data-pick-results]');
      const status = picker.querySelector('[data-pick-status]');
      let selected = '';
      const reset = picker.querySelector('[data-pick-all]');
      root.querySelectorAll('.rcl-parts-card select').forEach(select => {
        select.tabIndex = 0;
        window.addEventListener('load', () => { select.tabIndex = 0; }, {once:true});
        const card = select.closest('.rcl-parts-card');
        const link = card.querySelector('.rcl-parts-art');
        const image = link?.querySelector('img');
        const originalImage = image?.getAttribute('src');
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          if (!option?.value) return;
          card.querySelector('[data-part-price]').textContent = option.dataset.price;
          if (link) link.href = option.dataset.url;
          if (image) { image.removeAttribute('srcset'); image.src = option.dataset.image || originalImage; image.alt = card.querySelector('h3').textContent + ' — ' + (option.dataset.image ? option.textContent : 'example part photo'); }
        });
      });
      const move = element => {
        element.focus({preventScroll:true});
        element.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      };
      const showCategory = (category, scroll = true) => {
        const target = groups.find(group => group.dataset.partCategory === category);
        if (!target) return;
        groups.forEach(group => { group.hidden = group !== target; });
        results.hidden = false;
        reset.hidden = false;
        picker.querySelector('[data-pick-title]').textContent = target.querySelector('h2').textContent;
        status.textContent = target.querySelector('h2').textContent;
        if (scroll) move(results);
      };
      const selectPart = part => {
        selected = part;
        reset.hidden = false;
        picker.querySelectorAll('[data-pick-kind]').forEach(b => b.setAttribute('aria-pressed','false'));
        picks.forEach(pick => pick.setAttribute('aria-pressed', String(pick.dataset.pick === part)));
        groups.forEach(group => { group.hidden = true; });
        results.hidden = true;
        choice.hidden = !['seat','back'].includes(part);
        feet.hidden = part !== 'feet';
        const label = picks.find(pick => pick.dataset.pick === part)?.getAttribute('aria-label');
        if (label) status.textContent = label;
        if (!choice.hidden) move(choice);
        else if (!feet.hidden) move(feet);
        else showCategory({arm:'arm_covers',pillow:'pillows',lock:'gator_lock'}[part]);
      };
      picks.forEach(pick => {
        pick.addEventListener('click', () => selectPart(pick.dataset.pick));
        if (pick.tagName.toLowerCase() === 'g') pick.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); selectPart(pick.dataset.pick); }
        });
      });
      picker.querySelectorAll('[data-pick-kind]').forEach(button => button.addEventListener('click', () => { picker.querySelectorAll('[data-pick-kind]').forEach(b => b.setAttribute('aria-pressed', String(b === button))); showCategory(selected + '_' + button.dataset.pickKind); }));
      picker.querySelectorAll('[data-pick-category]').forEach(button => button.addEventListener('click', () => showCategory(button.dataset.pickCategory)));
      reset.addEventListener('click', () => {
        groups.forEach(group => { group.hidden = true; });
        choice.hidden = true; feet.hidden = true; results.hidden = true; reset.hidden = true;
        picks.forEach(pick => pick.setAttribute('aria-pressed','false'));
        status.textContent = ''; selected = '';
        picks[0]?.focus({preventScroll:true});
        picker.scrollIntoView({block:'start',behavior:'auto'});
      });
      groups.forEach(group => { group.hidden = true; });
      picker.hidden = false;
      root.classList.add('picker-ready');
      const fromHash = () => {
        if (location.hash.startsWith('#Part-')) showCategory(location.hash.slice(6), false);
      };
      fromHash();
      window.addEventListener('hashchange', fromHash);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
